// Waehlbares Symbol fuer den Startbildschirm.
//
// HARTE GRENZE, die in der Oberflaeche stehen muss: Das Symbol wird bei der
// Installation eingefroren. Ein Wechsel danach wirkt erst, wenn die App vom
// Startbildschirm entfernt und neu abgelegt wird. Ein Web-Gegenstueck zu
// setAlternateIconName gibt es nicht.
//
// Wie es wirkt: Beim Start wird das <link rel="manifest"> und das
// apple-touch-icon auf die gewaehlte Fassung umgehaengt. Ein per JavaScript
// ausgetauschtes Manifest uebernimmt der Browser sofort - genau daraus
// schoepft er beim Installieren. Kein Umbau an nginx oder Server noetig.

export interface AppSymbol {
  schluessel: string;
  name: string;
  /** Bild fuer die Vorschau in den Einstellungen. */
  vorschau: string;
  /** null = das mitgelieferte Standardsymbol, kein eigenes Manifest. */
  manifest: string | null;
  appleTouchIcon: string;
}

export const APP_SYMBOLE: AppSymbol[] = [
  {
    schluessel: "standard",
    name: "Standard",
    vorschau: "/icons/icon-192.png",
    manifest: null,
    appleTouchIcon: "/apple-touch-icon.png",
  },
  {
    schluessel: "sammlerbild",
    name: "Sammlerbild",
    vorschau: "/icons/sammlerbild/icon-192.png",
    manifest: "/manifest-sammlerbild.webmanifest",
    appleTouchIcon: "/icons/sammlerbild/apple-touch-icon.png",
  },
  {
    schluessel: "autos",
    name: "Autos",
    vorschau: "/icons/autos/icon-192.png",
    manifest: "/manifest-autos.webmanifest",
    appleTouchIcon: "/icons/autos/apple-touch-icon.png",
  },
];

const SPEICHER = "kdx_app_symbol";
const STANDARD = APP_SYMBOLE[0]!;

export function gewaehltesSymbol(): AppSymbol {
  try {
    const schluessel = localStorage.getItem(SPEICHER);
    return APP_SYMBOLE.find((s) => s.schluessel === schluessel) ?? STANDARD;
  } catch {
    // Privates Fenster oder gesperrte Speicherung: dann eben das Standardsymbol.
    return STANDARD;
  }
}

export function merkeSymbol(schluessel: string): void {
  try {
    localStorage.setItem(SPEICHER, schluessel);
  } catch {
    // Nicht speichern zu koennen ist kein Grund, die Auswahl abzubrechen;
    // angewandt wird sie trotzdem, sie haelt nur nicht ueber den Neustart.
  }
  wendeSymbolAn();
}

/** Haengt Manifest und apple-touch-icon auf die gewaehlte Fassung um. */
export function wendeSymbolAn(): void {
  const symbol = gewaehltesSymbol();

  const manifest = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
  if (manifest) {
    // Beim allerersten Aufruf den urspruenglichen Pfad merken, VOR jeder
    // Aenderung. Sonst gibt es kein Zurueck: wer die App mit einem anderen
    // Symbol oeffnet, haette den Standardpfad nirgends mehr stehen. Er steht
    // absichtlich nicht in dieser Datei, damit ein Namenswechsel bei
    // vite-plugin-pwa nicht hier nachgezogen werden muss.
    manifest.dataset.standard ??= manifest.href;
    manifest.href = symbol.manifest ?? manifest.dataset.standard;
  }

  const apple = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
  if (apple) apple.href = symbol.appleTouchIcon;
}
